import { contact, getMapsUrl } from "@/config/site";
import { waMessages } from "@/lib/whatsapp";
import WhatsAppLink from "@/components/feature/WhatsAppLink";
import Reveal from "@/components/feature/Reveal";

export default function Contact() {
  return (
    <section id="iletisim" className="scroll-mt-24 bg-background-300">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
            İletişim
          </p>
          <h2 className="mt-4 font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
            Bize ulaşın.
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <div className="flex h-full flex-col rounded-lg border border-background-300/60 bg-background-50 p-6 md:p-8">
              <ul className="space-y-6">
                <li className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-accent-500 text-accent-600">
                    <i className="ri-map-pin-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-primary-800">Adres</h3>
                    <p className="mt-1 text-foreground-700">{contact.address}</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-accent-500 text-accent-600">
                    <i className="ri-phone-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-primary-800">Telefon</h3>
                    <a
                      href={contact.phoneHref}
                      className="mt-1 inline-block text-foreground-700 transition-colors hover:text-accent-600"
                    >
                      {contact.phoneDisplay}
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-accent-500 text-accent-600">
                    <i className="ri-instagram-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-primary-800">Instagram</h3>
                    <a
                      href={contact.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-1 inline-block text-foreground-700 transition-colors hover:text-accent-600"
                    >
                      @{contact.instagramHandle}
                    </a>
                  </div>
                </li>
              </ul>

              <a
                href={getMapsUrl(contact.address)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-800 px-5 py-3 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-800 hover:text-background-50 sm:self-start"
              >
                <i className="ri-navigation-line" aria-hidden="true"></i>
                Yol Tarifi Al
              </a>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="flex h-full flex-col rounded-lg bg-primary-900 p-6 md:p-8">
              <h3 className="font-heading text-2xl text-background-50 md:text-3xl">
                WhatsApp'tan ulaşın
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-200/80 md:text-base">
                Randevu talebi, hizmet bilgisi ya da konum hakkında sorularınız için bize doğrudan
                WhatsApp'tan yazabilirsiniz.
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row lg:flex-col">
                <WhatsAppLink
                  message={waMessages.general}
                  label="WhatsApp'tan Yazın"
                  variant="whatsapp"
                  size="md"
                  sourceSection="contact"
                  className="w-full sm:w-auto lg:w-full"
                />
                <WhatsAppLink
                  message={waMessages.location}
                  label="Salon Konumunu Sor"
                  variant="dark-outline"
                  size="md"
                  icon={false}
                  sourceSection="contact_location"
                  className="w-full sm:w-auto lg:w-full"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}